import { render } from "./vSlider_Choose_Box.vue?vue&type=template&id=127cf114&scoped=true"
import script from "./vSlider_Choose_Box.vue?vue&type=script&lang=js"
export * from "./vSlider_Choose_Box.vue?vue&type=script&lang=js"

import "./vSlider_Choose_Box.vue?vue&type=style&index=0&id=127cf114&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127cf114"]])

export default __exports__